import React from "react";
import { Form, FormTypeEnum } from "../api";
import FormView from "../pages/Requests/FormViewPage";
import AssessmentViewComponent from "../pages/Assessment/AssessmentViewComponent";
import LinkedObjectViewComponent from "../pages/LinkedObject/LinkedObjectViewComponent";
import CommentComponent from "./CommentComponent";

interface Props {
  form: Form;
  requestId?: number;
  onSuccess: (result: any) => void;
  readonly?: boolean;
  values?: any;
}

const RenderViewComponent = ({ form, requestId, onSuccess, values }: Props) => {
  const renderForm = (type: FormTypeEnum) => {
    console.log(type);
    switch (type) {
      case FormTypeEnum.DYNAMIC:
        return (
          <FormView
            values={values}
            schema={form.schema_json.schema}
            formProps={form.schema_json.form}
            readonly={true}
            requestId={requestId}
            formId={form.id}
            onSuccess={() => {}}
          />
        );
      case FormTypeEnum.RISK_ASSESSMENT:
        return (
          <AssessmentViewComponent
            schema={form.schema_json.schema}
            formProps={form.schema_json.form}
            formId={form.id}
            requestId={requestId}
            readonly={true}
            onSuccess={() => {}}
          />
        );
      case FormTypeEnum.COMMENT:
        return (
          <CommentComponent
            schema={form.schema_json.schema}
            formProps={form.schema_json.form}
            formId={form.id}
            requestId={requestId}
            readonly={true}
            onSuccess={() => {}}
          />
        );
      case FormTypeEnum.LINKED_OBJECT:
        return (
          <LinkedObjectViewComponent formId={form.id} requestId={requestId} />
        );
      default:
        return null;
    }
  };

  return <>{renderForm(form.type!)}</>;
};

export default RenderViewComponent;
